import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import { Layout as LayoutV1 } from './LayoutV1';
import { Layout } from './Layout';
import { getMetaOverrideSet } from './metaOverrides/metaOverride';
import { metaOverrideSet as metaOverrideSetV1 } from './metaOverrides/metaOverrideV1';


const ReferralPage = ({ resource }) => {
  const dashboardV2 = resource.relationship(fr.relationships.imageMobile.name);
  const isMobile = useMobileLayout();

  return (
    <MetaResourceRenderer
      layout={dashboardV2 ? Layout : LayoutV1}
      resource={resource}
      metaOverrideSet={dashboardV2 ? getMetaOverrideSet(isMobile) : metaOverrideSetV1}
    />
  );
};

ReferralPage.defaultProps = {
};

ReferralPage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { ReferralPage };
